var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#4A4A4A",
  clipPath: "url(#Edit16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.168 2.4 1.43 1.43L7.65 10H6V8.35zm.013-2.4a1 1 0 0 0-.705.292L4 7.5V12h4.5l7.208-7.475a1 1 0 0 0 0-1.411L12.886.293A1 1 0 0 0 12.182 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 13.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H5a1 1 0 0 0 0-2H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-2 0z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Edit16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgEdit16;